import $ from 'jquery'
import invariant from 'ts-invariant'
import { domready } from './domready'
import { Popup } from './popup'
import { MSG_ADMIN_ENABLED, MSG_ADMIN_DISABLED, MSG_ADMIN_SAVED } from './users'

const debug = require('debug')('pm:admin-toggle')

domready(function installAdminToggle() {
  const checkboxes =
    document.querySelectorAll<HTMLInputElement>('.js-admin-toggle')

  if (checkboxes.length === 0) return

  checkboxes.forEach(checkbox => {
    const forInvitation = checkbox.dataset.forInvitation === 'true'

    checkbox.addEventListener('change', async () => {
      if (forInvitation) {
        handleChangeForInvitation(checkbox)
      } else {
        await handleChangeForExistingUser(checkbox)
      }
    })
  })

  function handleChangeForInvitation(checkbox: HTMLInputElement) {
    const isChecked = checkbox.checked
    debug('handleChangeForInvitation', { isChecked })

    window.postMessage(isChecked ? MSG_ADMIN_ENABLED : MSG_ADMIN_DISABLED)
  }

  let pendingAdminToggle: HTMLInputElement | null = null

  async function handleChangeForExistingUser(checkbox: HTMLInputElement) {
    const isChecked = checkbox.checked
    debug('handleChangeForExistingUser', { isChecked })

    if (isChecked) {
      // Let's keep the checkbox unchecked while the pop-up is open, so if the user cancels the pop-up,
      // the checkbox will remain unchecked. We will check it once we get a message from the pop-up.
      checkbox.checked = false
      pendingAdminToggle = checkbox

      const url = checkbox.dataset.enableUrl
      invariant(url, 'Missing data-enable-url')

      Popup.open()
      Popup.fetch(url)
    } else {
      const elParent = checkbox.parentElement
      invariant(elParent)

      elParent.classList.add('u-is-loading')
      try {
        const url = checkbox.dataset.disableUrl
        invariant(url, 'Missing data-disable-url')

        await disableAdmin(url)

        window.postMessage(MSG_ADMIN_DISABLED)
        window.postMessage(MSG_ADMIN_SAVED)
      } finally {
        elParent.classList.remove('u-is-loading')
      }
    }
  }

  async function disableAdmin(url: string) {
    return new Promise<void>((resolve, reject) => {
      $.ajax({
        url,
        method: 'PUT',
      })
        .done(resolve)
        .fail(reject)
    })
  }

  window.addEventListener('message', function handleMessage(e) {
    if (e.data === MSG_ADMIN_ENABLED) {
      // This message will be sent by the pop-up when admin has been successfully enabled.
      // Now it is safe to mark the checkbox as checked.
      debug('handleMessage', e)
      if (pendingAdminToggle) {
        pendingAdminToggle.checked = true
        pendingAdminToggle = null
      }
    }
  })
})
